import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clickLabel(event) {
    console.log("clickLabel");

    // event.preventDefault();

    this.element.querySelector("label").click()
  }
}
